import { render, staticRenderFns } from "./PlanSubscription.vue?vue&type=template&id=55b66131&scoped=true"
import script from "./PlanSubscription.vue?vue&type=script&lang=js"
export * from "./PlanSubscription.vue?vue&type=script&lang=js"
import style0 from "./PlanSubscription.vue?vue&type=style&index=0&id=55b66131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b66131",
  null
  
)

export default component.exports